import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { MissingServices } from './MissingServices';

import {
  addPerson as addPersonAction,
  MVI_ADD_NOT_ATTEMPTED,
  MVI_ADD_INITIATED,
  MVI_ADD_SUCCEEDED,
  MVI_ADD_FAILED,
  MVI_ADD_REFRESH_FAILED,
} from '../actions/addPerson';
import {
  trackAddPersonInitiated,
  trackAddPersonFailed,
  trackAddPersonSucceeded,
} from '../utils/tracking/addPersonTracking';

const message =
  'We’re doing some additional work to enable you to file a claim...';
const label = 'We’re doing some additional work';

const loading = title => (
  <div className="vads-l-grid-container vads-u-padding-left--0 vads-u-padding-bottom--5">
    <div className="usa-content">
      <h1>{title}</h1>
      <va-loading-indicator message={message} label={label} />
    </div>
  </div>
);

export const AddPerson = props => {
  const addPersonState = props?.mvi?.addPersonState;
  const { addPerson, formId } = props;

  // Fire add-person on first mount; useEffect avoids dispatching during render.
  useEffect(() => {
    if (addPersonState === MVI_ADD_NOT_ATTEMPTED) {
      addPerson(formId);
    }
  }, [addPersonState, addPerson, formId]);

  // Fire tracking on state transitions only. Keeping AddPerson mounted
  // through MVI_ADD_SUCCEEDED (#142609) would otherwise emit duplicate
  // events while refreshProfile is in flight.
  useEffect(() => {
    switch (addPersonState) {
      case MVI_ADD_INITIATED:
        trackAddPersonInitiated(formId);
        break;
      case MVI_ADD_FAILED:
        trackAddPersonFailed(formId);
        break;
      case MVI_ADD_SUCCEEDED:
        trackAddPersonSucceeded(formId);
        break;
      default:
        break;
    }
  }, [addPersonState, formId]);

  switch (addPersonState) {
    case MVI_ADD_INITIATED:
      return loading(props.title);
    case MVI_ADD_FAILED:
    case MVI_ADD_REFRESH_FAILED:
      return <MissingServices title={props.title} formId={formId} />;
    case MVI_ADD_SUCCEEDED:
      // Keep the loader during the profile refresh; otherwise the Veteran
      // briefly sees a red alert despite backend success (#142609).
      return loading(props.title);
    default:
      // MVI_ADD_NOT_ATTEMPTED (handled by the effect above) + unknown states.
      return null;
  }
};

AddPerson.propTypes = {
  addPerson: PropTypes.func.isRequired,
  // Defaults to the v1 form id downstream when absent.
  formId: PropTypes.string,
  // Optional: component renders null when absent (see default case).
  mvi: PropTypes.shape({
    addPersonState: PropTypes.oneOf([
      MVI_ADD_NOT_ATTEMPTED,
      MVI_ADD_INITIATED,
      MVI_ADD_SUCCEEDED,
      MVI_ADD_FAILED,
      MVI_ADD_REFRESH_FAILED,
    ]),
  }),
  title: PropTypes.string,
};

const mapDispatchToProps = {
  addPerson: addPersonAction,
};

export default connect(state => state, mapDispatchToProps)(AddPerson);
